import { useContext } from "react";
import GlobalContext, { DefaultGlobalContextI } from "@/context/global";

export const useGlobalContext = (): DefaultGlobalContextI => {
  return useContext(GlobalContext);
};

export const useUser = () => {
  const { glencocoUser } = useGlobalContext();

  return glencocoUser;
};
